import React from "react"
import PropTypes from "prop-types"
import monitaur from "../images/monitaur.png";

const Header = ({ siteTitle, menuLinks }) => (
 <header>
  <section className="hero top-header has-background-grey-darker">
     <div id="logo" class="container has-text-centered">
       <img className="is-centered" src={monitaur} width="390" alt="Monitaur Technologies Inc Logo"></img>
     </div>
  </section>
 </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
